import React from "react";
import { useStyles } from "./styles";

type CardLayoutProps = {
    title?: string;
    label?: React.ReactNode;
    action?: React.ReactNode;
    children?: React.ReactNode;
};

export default function CardLayout({ title, label, action, children }: CardLayoutProps) {
    const classes = useStyles();

    return (
        <div className={classes.card}>
            {title && <div className={classes.header}>{title}</div>}
            
            <div className={classes.content}>
                <div className={classes.labelSection}>{label || null}</div>
                {(action || children) && (
                    <div className={classes.actionSection}>{action || children}</div>
                )}
            </div>
        </div>
    );
}